module.exports = __webpack_public_path__ + "static/media/ES.92f911e5.svg";